$(function () {
    if (window.self != window.top) {
        $(document.body).addClass("in-iframe");
    }
});

window.readCookie = window.readCookie || function (k) {
    return (document.cookie.match('(^|; )' + k + '=([^;]*)') || 0)[2]
}
window.setCookie = window.setCookie || function (e, o, i) {
    var t = "";
    if (i) {
        var n = new Date;
        n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3), t = "; expires=" + n.toUTCString()
    }
    document.cookie = e + "=" + (o || "") + t + "; path=/"
}
window.eraseCookie = window.eraseCookie || function (e) {
    document.cookie = e + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
}

window.executeAfterConsentExists = (callback) => {
    if (typeof __cmp !== 'undefined' && !!__cmp) {

        let data = __cmp('getCMPData')
        if(!data){
            __cmp("addEventListener", ["consent", () => {
                setTimeout(() => {
                    callback()
                }, 400)
            }, true], null)
        }
        else{
            // the consent event does not always trigger? Anyways, here's wonderwall:
            let counter = 1000;
            let consentCheckInterval = setInterval(() => {
                let cmpData = __cmp('getCMPData');
                let vendorConsentLength = (!!cmpData && !!cmpData.vendorConsents) ? Object.keys(cmpData.vendorConsents).length : 0;
                counter--;
                // give up after ~150s so this doesn't poll forever when no consent decision ever appears
                if(vendorConsentLength > 0 || counter <= 0){
                    callback();
                    clearInterval(consentCheckInterval);
                }
            },150);
        }
    } else {
        setTimeout(() => {
            callback()
        }, 400);
    }
}

jQuery(function () {
    $(document).ready(function (event) {
        // a small fix because IE does not support window.location.origin
        if (!window.location.origin) {
            // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin =
                window.location.protocol +
                "//" +
                window.location.hostname +
                (window.location.port ? ":" + window.location.port : "");
        }

        //$("iframe").attr("src","about:blank");

        // display offer badge in header slider
        var $isHOB = $("#hide-offer-badge");
        if ($isHOB.length) {
            var HOBcontent = $(this)
                .find("#hide-offer-badge")
                .html();
            $("div#display-offer-badge").append(HOBcontent);
        }

        var $headerSocials = $("#header-socials");
        if (
            $headerSocials.length &&
            $headerSocials.is(":visible") &&
            $headerSocials.is(":empty")
        ) {
            var footerSocialsContent = $(".footer .footer-social ul.socials").html();
            $headerSocials.append(
                "<ul class='socials'>" + footerSocialsContent + "</ul>"
            );
        }

        /*var $staticSocials = $("#fixedShareButton");
        var $staticSocialsPopup = $("#fixedShareButtons-popup");
        $staticSocials.click(function (e) {
            e.preventDefault();
            if (
                $staticSocials.length &&
                $staticSocials.is(":visible") &&
                !$staticSocialsPopup.is(":empty")
            ) {
                $staticSocialsPopup.toggleClass("open");
            }
        });*/

        var $staticContact = $("#fixedContactButton");
        var $staticContactPopup = $("#fixedShareContact-popup");
        $staticContact.click(function (e) {
            e.preventDefault();
            if (
                $staticContact.length &&
                $staticContact.is(":visible") &&
                !$staticContactPopup.is(":empty")
            ) {
                $staticContactPopup.toggleClass("open");
            }
        });

        var $staticContactSmall = $("#fixedContactButton-small");
        var $staticContactPopupSmall = $("#fixedShareContact-popup-small");
        $staticContactSmall.click(function (e) {
            e.preventDefault();
            if (
                $staticContactSmall.length &&
                $staticContactSmall.is(":visible") &&
                !$staticContactPopupSmall.is(":empty")
            ) {
                $staticContactPopupSmall.toggleClass("open");
            }
        });

        //********************some SEO stuff****************************** */
        if (!!sessionStorage) {
            let fromAirBnB = sessionStorage.getItem("fromAirBnB");

            //first we check if we are on a detail page
            if ($(".detailpage-header").length > 0) {
                if (!!fromAirBnB) {
                    window.pixelpoint.tagManager.event("cameFromAirBnB", {
                        eventname: "cameFromAirBnB"
                    });
                }
            }

            //on each site we remove the flag
            sessionStorage.removeItem("fromAirBnB");
        }
        $("body").on("click", "a", function () {
            if (
                $(".rbnb-wrapper").length > 0 ||
                $(".external-map-wrapper").length > 0
            ) {
                if (
                    $(this).closest(".rbnb-wrapper").length > 0 ||
                    $(this).closest(".external-map-wrapper").length > 0
                )
                    sessionStorage.setItem("fromAirBnB", true);
            }
        });
        //**************************************************************** */


        checkForItemWithBanderole();
    });

    dedectAndroidVersion();

    //$("body").append("<a id='scrollToTopButton' title='nach oben'><i class='icon-arrow-big-up'></a>");

    var appendButtonHeight = $(window).height();
    var appendButtonHeightBottomButtons = $(window).height() * 0.5;

    if ($(window).width() <= 480) {
        appendButtonHeight = $(window).height() * 1.3;
    }

    if (Foundation.MediaQuery.current == "small") {
        $("#bottom-button-wrapper").hide();
    }

    var iScrollPos = 0;
    var scrollingGetParam = new RegExp(
        "[?&]" + "testScrollingMenu" + "=([^&#]*)"
    ).exec(window.location.href);

    var scrolled = false;
    $(window).scroll(function () {
        scrolled = true;
    });
    setInterval(function () {
        if (scrolled) {
            scrolled = false;

            if (Foundation.MediaQuery.current == "small") {
                if ($(this).scrollTop() > appendButtonHeightBottomButtons) {
                    //$('#scrollToTopButton').fadeIn();
                    $("#bottom-button-wrapper").fadeIn();
                } else {
                    //$('#scrollToTopButton').fadeOut();
                    $("#bottom-button-wrapper").fadeOut();

                    setTimeout(function () {
                        $(".fixed-button-popup").removeClass("open");
                    }, 250);
                }
            } else {
                if ($(this).scrollTop() > appendButtonHeight) {
                    $("#scrollToTopButton").fadeIn();
                } else {
                    $("#scrollToTopButton").fadeOut();

                    setTimeout(function () {
                        $(".fixed-button-popup").removeClass("open");
                    }, 250);
                }
            }

            // scroll effect on Large Screens
            if (Foundation.MediaQuery.current == "large") {
                var headerHeight = $(".header-wrapper > .header > .row").height();
                //var headerPositionNew = headerHeight + 18;
                var headerPositionNew = headerHeight + 2;
                var iCurScrollPos = $(this).scrollTop();

                // ZP 08.05.2020
                /**
                 * this change was made as part of the ticket 1069. The customer requestet that the full header is
                 * only shown when the user scrollt to the top of the page
                 */
                if (iCurScrollPos == 0) {
                    $(".header-wrapper .header").css("top", "auto");
                } else {
                    $(".header-wrapper .header").css("top", "-" + headerPositionNew + "px");
                }
            } else {
                $(".header-wrapper .header").css("top", "auto");
                $(".header-wrapper .header > .row").removeAttr("style");
            }
            // scroll effect on Large Screens - END
        }
    }, 100);

    //Click event to scroll to top
    $("#scrollToTopButton").click(function () {
        $("html, body").animate({scrollTop: 0}, 800);
        // reset focus to first visible link of page
        document.activeElement.blur();
        $(".header a:visible").first().focus();
        return false;
    });

    $("#scrollDownButton").click(function () {
        $("html, body").animate(
            {
                scrollTop: $(".dce-header").height() + 10 // +$(".dce-header").offset().top
            },
            800
        );
        return false;
    });

    if ($("#sidebar-chatbox").length != 0) {
        var title = $("#sidebar-chatbox")
            .find("h4")
            .text();
        var telLink = $("#sidebar-chatbox a.phone-number").attr("href");
        $("#bottom-contact-box h6").text(title);
        $("#bottom-contact-box a.contact-phone").attr("href", telLink);
    } else {
        $("#bottom-button-wrapper").addClass("no-contact-box");
        $("#bottom-contact-box").addClass("hide");
        $("#fixedChatButton").addClass("hide");
    }

    // remove first big letter, when char is a number
    $(".tx-dce-pi1 .verticapital-blue, .tx-dce-pi1 .capital-blue, .tx-dce-pi1 .capital-white, .tx-dce-pi1 .capital, .supermenu .capital, .supermenu .capital-white").each(function () {
        var $this = $(this);
        var headlineText = $.trim($this.text());
        var firstLetter = headlineText.charAt(0);

        if (!isNaN(firstLetter)) {
            $this.addClass("no-big-captial");
        }
    });

    // smooth scrolling to anchor links on the actual page
    $("a.internal-link").click(function () {
        var href = $.attr(this, "href");

        if (href.indexOf("#") > -1) {
            var hrefArray = href.split("#");
            var targetId = hrefArray[1];

            if ($("#" + targetId).length != 0) {
                event.preventDefault();

                var headerHeight = $(".header-wrapper .header").height() + 20;

                $("html, body").animate(
                    {
                        scrollTop: $("#" + targetId).offset().top - headerHeight
                    },
                    500
                );
            }
        }
    });

    var privateFunctions = {
        getHeight(element) {
            if (element.is(":visible") && element.height() > 0) {
                return element.outerHeight(true);
            }
            var previousCss = element.attr("style");
            element.addClass("no-transition");
            element.css({
                //position: 'absolute',
                visibility: "hidden",
                //display: 'block',
                "max-height": "none"
            });
            var height = element.outerHeight(true);
            element.attr("style", previousCss ? previousCss : "");
            element.removeClass("no-transition");
            return height;
        }
    };

    // not used ? - UPDATE: used on prices :S
    initPriceReadMore();

    $(".show-more-content").each(function () {
        var $this = $(this);
        if ($this.is(":empty")) {
            $this.parent().hide();
        }
    });

    $(window).on('load', function () {
        $(".show-more").each(function () {
            var $this = $(this);
            $this.find("[data-max-height]").each(function () {
                var height = privateFunctions.getHeight($(this));
                $(this).data("height", height);
            });

            $this.find(".show-more-arrow").on("click", function (e) {
                if (!$this.hasClass("multi-level")) {
                    $this.toggleClass("open");
                    $this.find("[data-max-height]").each(function () {
                        if ($this.hasClass("open"))
                            $(this).css("max-height", $(this).data("height"));
                        else $(this).css("max-height", "");
                    });
                } else {
                    if ($this.hasClass("open")) {
                        $this
                            .find("[data-max-height]")
                            .css("max-height", "")
                            .removeClass("is-open");
                        $this.removeClass("open").removeClass("visible");
                    } else {
                        $this.addClass("visible");
                        $this.find("[data-max-height]").each(function () {
                            if ($(this).hasClass("is-open")) {
                                return true;
                            }
                            $(this)
                                .addClass("is-open")
                                .css("max-height", $(this).data("height"));
                            return false;
                        });
                        if ($this.find("[data-max-height]").not(".is-open").length == 0) {
                            $this.addClass("open");
                        }
                    }
                }
            });
        });
    });
    // not used ? - END

    /*
          $('.swipebox').swipebox({
              removeBarsOnMobile: false,
              hideBarsDelay: 0,
              loopAtEnd: false
          });
      //*/

    // FIX: jQuery 3.x compatibility
    $(document).on('click', '.swipebox:not(.slick-slide .swipebox)', function(e) {
        e.preventDefault();
        var $this = $(this);
        var images = [{
            href: $this.attr('href'),
            title: $this.attr('title') || ''
        }];
        $.swipebox(images, {
            removeBarsOnMobile: false,
            hideBarsDelay: 0,
            loopAtEnd: false
        });
    });

    $(
        "body"
    ).on(
        "click",
        ".slick-slider .swipebox, .slick-slider .hover-display",
        function (e) {
            e.preventDefault();
            var swipeGallery = $(e.target).closest(".slick-slider");
            if (swipeGallery.length == 0) return;
            var images = [];
            swipeGallery
                .find(".slick-slide")
                .not(".slick-cloned")
                .find(".swipebox")
                .each(function () {
                    images.push({
                        href: $(this).attr("href")
                    });
                });
            $.swipebox(images, {
                removeBarsOnMobile: false,
                hideBarsDelay: 0,
                loopAtEnd: false
            });
        }
    );

    /*
          $('.swipebox').each(function(){
              var $this = $(this);
              if($this.closest(".slick-initialized").length == 0){
                  $this.swipebox({
                      removeBarsOnMobile: false,
                      hideBarsDelay: 0,
                      loopAtEnd: false
                  });
              }
              else{
                  $this.closest(".slick-initialized").on("click",".swipebox",function(e){
                      e.preventDefault();
                      var swipeGallery = $(e.target).closest(".slick-initialized");
                      if(swipeGallery.length == 0)
                          return;
                      var images = [];
                      swipeGallery.find(".slick-slide").not(".slick-cloned").find(".swipebox").each(function(){
                          images.push({href:$(this).attr("href")});
                      });
                      $.swipebox(images,{
                          removeBarsOnMobile: false,
                          hideBarsDelay: 0,
                          loopAtEnd: false
                      });
                  });
              }
          });
      //*/

    /*
          $(".swipe-gallery").on("click",".swipebox",function(e){
              e.preventDefault();
              var swipeGallery = $(e.target).closest(".swipe-gallery");
              if(swipeGallery.length == 0)
                  return;
              var images = [];
              swipeGallery.find(".slick-slide").not(".slick-cloned").find(".swipebox").each(function(){
                  images.push({href:$(this).attr("href")});
              });
              $.swipebox(images,{
                  removeBarsOnMobile: false,
                  hideBarsDelay: 0,
                  loopAtEnd: false
              });
          });
      //*/

    $(
        document.body
    ).on("click touchend", "#swipebox-slider .current img", function (e) {
        return false;
    });
    $(document.body).on("click touchend", "#swipebox-slider .current", function (
        e
    ) {
        //$('#swipebox-close').trigger('click');
        return false;
    });

    $(document).on("lity:open", function (event, instance) {
        $("body").addClass("modalOpen");
    });
    $(document).on("lity:close", function (event, instance) {
        $("body").removeClass("modalOpen");
    });

    $(".tabs-title").on("click", "a", function (e) {
        var parentModule = $(e.target).closest(
            "[data-tag-event-click='moduleClicked']"
        );
        if (parentModule.length > 0) parentModule.click();
    });

    $(".pp-form-element.current-date").each(function () {
        var currentDate = moment().format("DD.MM.YYYY");
        $(this)
            .val(currentDate)
            .after($(`<label class="current-date-display">${currentDate}</label>`));
    });

    if ($(window).width() < 640) {
        $(".tabMobileAccordion").on("click", ".accordion-title", function () {
            var $clickedElem = $(this);

            setTimeout(function () {
                //$('html,body').animate({scrollTop: $('.is-active').offset().top - $('.header-wrapper .header').height() - 5}, 800);
                $("html,body").animate(
                    {
                        scrollTop:
                            $clickedElem.offset().top -
                            $(".header-wrapper .header").height() -
                            5
                    },
                    800
                );
            }, 250); //Adjust to match slideSpeed
        });
    }

    /* ********* tag manager stuff ******************* */
    $(
        "#sidebar-chatbox"
    ).on("click", ".brandenbutton.brandenbutton-blue", function (e) {
        var targetText = $(e.target)
            .closest(".brandenbutton.brandenbutton-blue")
            .text();
        var targetClickText = $(e.target)
            .closest(".brandenbutton.brandenbutton-blue")
            .find("a")
            .attr("onclick");
        if (_.includes(targetText, "Insidertipps"))
            window.pixelpoint.tagManager.event("insiderClick", {
                eventname: "insiderClick"
            });
        else if (_.includes(targetClickText, "Insidertipps"))
            window.pixelpoint.tagManager.event("insiderClick", {
                eventname: "insiderClick"
            });
    });

    $(".openinghours-price-box").on("click", ".einklappen", function (e) {
        var target = $(e.target).closest(".einklappen");
        var isClosed = target.hasClass("active");
        var text = "";
        if (isClosed) {
            text = target.find(".text1").text();
        } else {
            text = target.find(".text2").text();
        }
        window.pixelpoint.tagManager.event("Mehr Infos anzeigen", {
            eventname: "Mehr Infos anzeigen",
            NameMehrInfos: text,
            OffenMehrInfos: !isClosed //this event fires before the box is opened
        });
    });
    $(".openinghours-price-box").on("click", ".arrow-open", function (e) {
        var target = $(e.target).closest(".arrow-open");
        var isClosed = !target.closest(".transparent-gradient").hasClass("open");
        var text = "";
        if (isClosed) {
            text = target.find(".text2").text();
        } else {
            text = target.find(".text1").text();
        }
        window.pixelpoint.tagManager.event("Mehr Infos anzeigen", {
            eventname: "Mehr Infos anzeigen",
            NameMehrInfos: text,
            OffenMehrInfos: isClosed // this event fires after the box is opened. So it needs to be the inverse
        });
    });

    $("body").on("click", ".overlaykarte .lity-close", function () {
        window.pixelpoint.tagManager.event("Karte-Schließen-Klick", {
            eventname: "Karte-Schließen-Klick"
        });
    });
    /* *********************************************** */

    //---------------------*/
    if ($("#ppcarto > div[data-pp-interchange]").length > 0) {
        var interchangeData = $("#ppcarto > div[data-pp-interchange]").data(
            "pp-interchange"
        );
        var mapInterchange = null;
        $(
            "#ppcarto > div[data-pp-interchange]"
        ).on("replaced.zf.interchange", function () {
            if (mapInterchange == null) return;
            var match;
            for (var i in mapInterchange.rules) {
                if (mapInterchange.rules.hasOwnProperty(i)) {
                    var rule = mapInterchange.rules[i];
                    if (window.matchMedia(rule.query).matches) {
                        match = rule;
                    }
                }
            }

            if (match) {
                if (mapInterchange.currentPath === match.path) return;
                if (match.path.match(/\.(gif|jpg|jpeg|png|svg|tiff)([?#].*)?/i)) {
                    $("#ppcarto > div[data-pp-interchange]").css({
                        "background-image": "url(" + match.path + ")"
                    });
                }
            }
        });
        $("#ppcarto > div[data-pp-interchange]")
            .attr("data-interchange", interchangeData)
            .data("interchange", interchangeData);
        mapInterchange = new Foundation.Interchange(
            $("#ppcarto > div[data-pp-interchange]"),
            {}
        );
    }
    /*
      $(".extbase-debugger").hide();

      if($(".extbase-debugger").length > 0 && !$(".extbase-debugger").is(":visible")){
          setTimeout(function () {
              console.log("reinit");
              $( window ).trigger('orientationchange');
          }, 250);
      }
      */

    $(document).on("invalid.zf.abide", function (ev, elem) {
        $(ev.target).closest("form").removeClass("valid").addClass("invalid");
    })
        // field element is valid
        .on("valid.zf.abide", function (ev, elem) {
            $(ev.target).closest("form").removeClass("invalid").addClass("valid");
        });

    $(".checkbox-helper").each(function (e) {
        var container = $(this);
        var label = container.find("label");
        var checkboxId = label.attr("for");
        label.attr("for", "");
        label.addClass("clickable");
        var onClickFunc = _.debounce(function () {
            $(`#${checkboxId}`).prop("checked", !$(`#${checkboxId}`).prop("checked"));
        }, 200);
        container.on("click touchstart", "label", function () {
            onClickFunc();
        });
    });


    /* ********* TPBB - Scrolling internal Page Links ******************* */
    setTimeout(function () {
        if (location.hash) {
            /* we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116 */
            // window.scrollTo(0, 0);
            var target = location.hash.split('#');
            //smoothScrollTo($('#' + target[1]));
            if($('#' + target[1]).has("[data-accordion]")) {
                // is scrolled when open accordion
                var $firstAccordionItem = $('#' + target[1]).find("[data-accordion-item]:first-of-type");
                if($firstAccordionItem.find("a.accordion-title").length) {
                    $firstAccordionItem.find("a.accordion-title").trigger('click');
                }
            } else {
                window.pixelpoint.utilities.scrollTo($('#' + target[1]), false, 0);
            }
        }
    }, 20);

    // taken from: https://css-tricks.com/snippets/jquery/smooth-scrolling/
    $('a[href*="#"]:not([role="tab"])').click(function (event) {
        if (
            this.hash != "#" &&
            this.hash != "" &&
            !$(this).hasClass("open-in-modal")
        ) {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                event.preventDefault();
                //smoothScrollTo($(this.hash));
                window.pixelpoint.utilities.scrollTo($(this.hash), false, 0);
                return false;
            }
        }
    });

    // own accordion (no foundation)
    $('.accordion-comfort-barrierfree.accordion .accordion-title[data-accordion-trigger]').on('click', function() {
        var $accordion = $(this).closest('.accordion');
        var $accordionContent = $(this).next('.accordion-content');

        // Close all other open items in this accordion
        $accordion.find('.accordion-content').each(function() {
            if (this !== $accordionContent[0] && $(this).attr('aria-hidden') === 'false') {
                $(this).attr('aria-hidden', 'true');
                $(this).prev('.accordion-title').attr('aria-expanded', 'false');
                $(this).parent().removeClass('is-active');
            }
        });

        // Toggle the clicked item
    var isOpen = $accordionContent.attr('aria-hidden') === 'false';
    $(this).attr('aria-expanded', !isOpen);
    $(this).parent().toggleClass('is-active', !isOpen);
    $accordionContent.attr('aria-hidden', isOpen ? 'true' : 'false');
    });

    //see function description below
    injectZeroWidthSpace();


    //******************** Web Share API ****************************** */
    $("a.web-share").on("click", function (e) {
        e.preventDefault();
        if (navigator.share) {
            window.pixelpoint.tagManager.event("Social-Media-Teilen", {
                eventname: "Social-Media-Teilen"
            });
            navigator.share({
                title: $(this).attr("data-title"),
                url: $(this).attr("data-url")
            }).then(() => {
                // TPBB-1149 last few comments
                window.pixelpoint.tagManager.event("Social-Media-Teilen-Erfolg", {
                    eventname: "Social-Media-Teilen"
                });
                console.log('Thanks for sharing!');
            }).catch((e) => {
                window.pixelpoint.tagManager.event("Social-Media-Teilen-Abbruch", {
                    eventname: "Social-Media-Teilen"
                });
                console.error(e);
            });
        } else {
        }
    });
    //**************************************************************** */
});

function smoothScrollTo(target) {
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    if (target.length) {
        var fixedHeaderHeight = 0;

        if ($(".header-wrapper .header .main-nav").is(":visible")) {
            fixedHeaderHeight = $(".header-wrapper .header .main-nav").height();
        } else if ($(".header-wrapper .header .header-row").is(":visible")) {
            fixedHeaderHeight = $(".header-wrapper .header .header-row").height();
        }

        $('html,body').animate({
            scrollTop: target.offset().top - fixedHeaderHeight
        }, 1000);
    }
}


function dedectAndroidVersion() {
    var navU = navigator.userAgent;

    // Android Mobile
    var isAndroidMobile =
        navU.indexOf("Android") > -1 &&
        navU.indexOf("Mozilla/5.0") > -1 &&
        navU.indexOf("AppleWebKit") > -1;

    // Apple webkit
    var regExAppleWebKit = new RegExp(/AppleWebKit\/([\d.]+)/);
    var resultAppleWebKitRegEx = regExAppleWebKit.exec(navU);
    var appleWebKitVersion = resultAppleWebKitRegEx === null ? null : parseFloat(regExAppleWebKit.exec(navU)[1]);

    // Chrome
    var regExChrome = new RegExp(/Chrome\/([\d.]+)/);
    var resultChromeRegEx = regExChrome.exec(navU);
    var chromeVersion =
        resultChromeRegEx === null ? null : parseFloat(regExChrome.exec(navU)[1]);

    // Native Android Browser
    var isAndroidBrowser =
        (isAndroidMobile &&
            (appleWebKitVersion !== null && appleWebKitVersion < 537)) ||
        (chromeVersion !== null && chromeVersion < 37);

    // ie
    var msie = navU.indexOf("MSIE ");

    if (isAndroidBrowser) {
        $("html").addClass("native-android-browser");
    } else if (/Edge\/\d./i.test(navigator.userAgent)) {
        $("html").addClass("microsoft-edge");
    } else if (msie > 0 || !!navU.match(/Trident.*rv\:11\./)) {
        $("html").addClass("internet-explorer");
    } else if (navU.match(/(iPod|iPhone|iPad)/)) {
        $("html").addClass("ios-device");
    } else {
    }

    if (navU.indexOf("Android") > -1) {
        //&& ua.indexOf("Mobile");
        $("html").addClass("android-device");
    }
}

function changeButtonText(elem, buttonTextOrig, buttonText) {
    /*
      var $elem = $(elem);
      if (!!$elem.hasClass('clicked')) {
          $elem.removeClass("clicked");
          return true;
      } else {
          event.preventDefault();
          elem.innerHTML = buttonText;

          setTimeout(function () {
              $elem.addClass("clicked");
              $elem.click();
              elem.innerHTML = buttonTextOrig;
          }, 150);
      }
      //*/
    //*
    if (!(window.pixelpoint.isMobile.any() && elem.target == "_blank")) {
        event.preventDefault();
        elem.innerHTML = buttonText;
        if (elem.target == "_blank") {
            setTimeout(function () {
                window.open(elem.href, "_blank");

                elem.innerHTML = buttonTextOrig;
            }, 150);
        } else {
            setTimeout(function () {
                location.href = elem.href;

                if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                    elem.innerHTML = buttonTextOrig;
                }
            }, 150);
        }
    }
    //*/
}

function equalHeight(group, parentElem) {
    if (group.length) {
        var tallest = 0;

        if (!group.hasClass("slick-slide")) {
            group.removeAttr("style");
        }

        if (parentElem) {
            if (
                parseFloat(group.parent().css("width")) !=
                parseFloat(group.css("width")) ||
                group.parent().width() != group.width()
            ) {
                group.each(function () {
                    var thisHeight = $(this).height();
                    if (thisHeight > tallest) {
                        tallest = thisHeight;
                    }
                });
                group.each(function () {
                    this.style.setProperty('height', `${tallest}px`, 'important');
                });
            }
        } else {
            group.each(function () {
                var thisHeight = $(this).height();
                if (thisHeight > tallest) {
                    tallest = thisHeight;
                }
            });
            //group.height(tallest);
            group.css('cssText', `height:${tallest}px !important;`);
        }
    }
}

function initPriceReadMore() {
    var treshold = 20;

    $(".arrow-open").each(function () {
        var $this = $(this);
        var transparentGradient = $this.closest(".transparent-gradient");
        if (transparentGradient.length == 0) return;

        transparentGradient.addClass("active");
        var difference =
            transparentGradient.get(0).scrollHeight - transparentGradient.height();
        if (difference < treshold) {
            transparentGradient.addClass("open");
            $this.hide();
            $this.parent().css("padding-bottom", "0");

            return;
        }

        $this.off("click").on("click", function (e) {
            if (transparentGradient.hasClass("open")) {
                var $scrollToElement = $this.prev();

                if ($this.parent().hasClass("scrollUpOnCloseReadMore")) {
                    $scrollToElement = $this.parent();
                } else if (
                    $this
                        .parent()
                        .parent()
                        .hasClass("scrollUpOnCloseReadMore")
                ) {
                    $scrollToElement = $this.parent().parent();
                } else if (
                    $this
                        .parent()
                        .parent()
                        .parent()
                        .hasClass("scrollUpOnCloseReadMore")
                ) {
                    $scrollToElement = $this
                        .parent()
                        .parent()
                        .parent();
                } else {
                }

                $("html, body").animate(
                    {
                        scrollTop:
                            $scrollToElement.offset().top -
                            $(".header-wrapper .header").height() -
                            10
                    },
                    800
                );

                $(this).attr(
                    "title",
                    $(this)
                        .find(".text2")
                        .first()
                        .text()
                );
            } else {
                $(this).attr(
                    "title",
                    $(this)
                        .find(".text1")
                        .first()
                        .text()
                );
            }
            transparentGradient.toggleClass("open");
        });
    });

    /* **************************************************************************** */
    //here we do everything that needs to be done if the user supresses cookies
    if (!readCookie("pp_allow_third_party_cookies")) {
        /*
                $("[data-lity]").each(function () {
                    var href = $(this).attr("href");
                    if (href.includes("www.youtube.com")) {
                        href = href.replace("www.youtube.com", "www.youtube-nocookie.com");
                        $(this).attr("href", href);
                    }
                    else if (href.includes("youtube.com")) {
                        href = href.replace("youtube.com", "www.youtube-nocookie.com");
                        $(this).attr("href", href);
                    }
                });
        //*/
        /*
        $(document).on("lity:open", function(event, instance) {
          var href = instance.opener().attr("href") || "";
          if(href.indexOf("youtube.com") !== -1){
              $(".lity-youtube").remove();
              window.open(href,"_blank");
          }
        });
        //*/
    }
    /* **************************************************************************** */
}


function checkForItemWithBanderole() {
    $(".item-banderole").each(function () {
        var $this = $(this);
        var $thisParentTeaser = $this.parent().parent();

        //$thisParents.find(".item.teaser").addClass("item-with-banderole");
        if ($thisParentTeaser.hasClass("item") && $thisParentTeaser.hasClass("teaser")) {
            $thisParentTeaser.addClass("item-with-banderole");
        }
    });
}

/**
 * this function has one purpose, taking specific elements and injecting their inner text with zero width space characters.
 * We do this to enable breaking text on specific characters
 * function was made by me (ZP) and I am aware that polluting the global namespace is bad practice
 */
function injectZeroWidthSpace() {
    let charactersToBreak = ["/", "\\", "-", "_", "(", "[", "<", ")", "]", ">"];
    let zeroWidthSpace = "\u200b";

    let selectors = [
        "table.price-table td.position"
    ];

    selectors.forEach(selector => {
        $(selector).each(function () {

            let replaceRecursive = function (elem) {

                if (elem[0].nodeType === 3) {
                    let contents = elem.text();
                    charactersToBreak.forEach(char => {
                        contents = contents.replaceAll(char, `${char}${zeroWidthSpace}`);
                    });
                    elem[0].nodeValue = contents;
                } else {
                    elem.contents().each(function () {
                        replaceRecursive($(this));
                    });
                }
            }
            replaceRecursive($(this));
        });
    });
}
